import React, {useState} from 'react';
import styled, {css} from 'styled-components';

import {useUserDataContext} from '@bootcamp/web/src/contexts/UserData';
import {useTimerContext} from '@bootcamp/web/src/contexts/TestTimer';
import {useTestNavigatorContext} from '@bootcamp/web/src/contexts/TestNavigator';
import {useModalContext} from '@bootcamp/web/src/contexts/Modal';
import {ReactComponent as Strikethrough} from '../assets/pencil.svg';

import flag from '../assets/flag-blue.png';
import maximize from '../assets/maximize.png';
import minimize from '../assets/minimize.png';

import flagFilled from '../assets/flag-blue-filled.png';
import {ReactComponent as Clock} from '../assets/clock.svg';
import {QuestionIcon} from '../../NCLEXQBank/shared';

const Container = styled.div`
  width: 100%;
  flex: 1;
  display: flex;
  flex-direction: column;
  font-family: Tahoma !important;
  background: #F2F3F5;
  overflow: auto;

  ${({mcatTheme}) => mcatTheme === 'black' && css`
    background: black;
    color: white;
    ${ReviewText} {
      color: white;
    }
    ${Title} {
      color: white;
      ${ReviewButton} {
        background: transparent;
        color: white;
      }
    }
    ${ReviewTable} {
      color: white;
      background: black;
      th {
        color: white;
      }
      tr {
        border-bottom: 1px solid white;
      }
      td {
        color: white;
        span {
          color: white;
        }
      }
      
    }
    ${FilterTab} {
      color: white;
    }
    ${FilterTabContainer} {
      border-bottom: 1px solid white;
    }
  `}

  ${({mcatTheme}) => mcatTheme === 'salmon' && css`
    background: #FDD3C5;
    color: black;
    ${ReviewText} {
      color: black;
    }
    ${Title} {
      color: black;
      ${ReviewButton} {
        background: transparent;
        color: black;
      }
    }
    ${ReviewTable} {
      color: black;
      background: #FDD3C5;
      th {
        color: black;
      }
      tr {
        border-bottom:1px solid black;
      }
      td {
        color: black;
        span {
          color: black;
        }
      }
    }
    ${FilterTab} {
      color: black;
    }
    ${FilterTabContainer} {
      border-bottom: 1px solid black;
    }
  `}
`;

const Title = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  font-size: 28px;
  font-weight: bold;
  color: black;
  margin: 32px;
  margin-bottom: 56px;
  margin-left: 60px;
`;
const Left = styled.div`
  font-size: 21px;
`;
const Right = styled.div`
  margin-left: auto;
  font-size: 15px;
`;
const Time = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 2px;
`;
const ClockIcon = styled(Clock)`
  width: 16px;
  height: 16px;
  margin-right: 4px;
`;
const Count = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
`;
const CountIcon = styled(QuestionIcon)`
  margin-right: 4px;
`;
const IconWrapper = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;
`;
const FlagWrapper = styled(IconWrapper)`
  margin-left: auto;
`;
const Highlight = styled(IconWrapper)`
  margin-right: 16px;
`;

const CollapsibleTop = styled.div`
  display: flex;
  background: ${({theme}) => theme.colors.prometricPalette.mcat.light};
  padding: 4px;
  align-items: center;
  cursor: pointer;
  color: white;
  font-family: Verdana;
  font-size: 19px;
  font-style: normal;
  font-weight: 400;
  line-height: 100%; /* 19px */
`;
const CollapsibleSection = props => {
  const [isOpen, setIsOpen] = useState(true);
  return (
    <Container>
      <CollapsibleTop onClick={() => setIsOpen(!isOpen)}>
        <div style={{display: 'flex', alignItems: 'center', width: '100%'}}>
          <img src={isOpen ? minimize : maximize} style={{width: 16, height: 16, marginRight: 8}}/>
          {props.title}
        </div>
      </CollapsibleTop>
      {isOpen && props.body}
    </Container>
  )
}

const QuestionContainer = styled.div`
  width: calc(100%/3);
  display: flex;
  flex-direction: row;
  background: ${({theme}) => theme.colors.neutralsPalette.white};
  padding: 12px 16px;
  align-items: center;
  border: 1px solid black;
  cursor: pointer;
  white-space: nowrap;

  ${({theme}) => theme.mediaQueries.tablet} {
    flex-direction: column;
    align-items: flex-start;
    gap: 4px;
  }
`;

const QuestionWrapper = styled.div`
  display: flex;
  width: 50%;
  align-items: center;

  span {
    margin-right: 4px;
  }

  ${({theme}) => theme.mediaQueries.tablet} {
    width: auto;
  }

  ${({theme}) => theme.mediaQueries.mobileL} {
    span {
      display: none;
    }
  }
`;
const QuestionResult = styled.div`
  display: flex;
  justify-content: flex-end;
  color: red;
  width: 50%;

  ${({theme}) => theme.mediaQueries.tablet} {
    width: auto;
  }
`;

const ReviewTable = styled.table`
  border-collapse: collapse;
  border-radius: 8px;
  background: white;
  margin: 30px 32px;
  font-family: Arial;
  th {
    color: #666666;
    text-align: left;
    text-transform: uppercase;
    padding-left: 15px;
    padding-top: 22px;
    height: 55px;
    font-size: 12px;
    font-weight: bold;
    letter-spacing: 1.25px;
  }
  tr {
    border-bottom:1px solid #DFE1E1;
    &:last-child {
      border-bottom: none;
    }
  }
  td {
    padding-left: 15px;
    padding-top: 22px;
    height: 55px;
    vertical-align: middle;
    color: black;
  }
`;
const FilterTabContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  border-bottom: 1px solid #007394;
  margin: 0px 32px;
`;
const FilterTab = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: bold;
  font-size: 12pt;
  color: #333333;
  width: 100%;
  cursor: pointer;
  ${({selected, mcatTheme}) => selected && css`
    color: #007394;
    border-bottom: 2px solid ${mcatTheme === 'salmon' ? 'black' : mcatTheme === 'black' ? 'white' : `#007394`};
  `}
`;

const ReviewText = styled.div`
  cursor: pointer;
  font-size: 16px;
  font-weight: 700;
  color: #007394;
`;

const ReviewButton = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  background: #007394;
  color: white;
  border-radius: 6px;
  height: 25px;
  padding: 8px 16px;
  cursor: pointer;
  font-size: 19px;
  margin-left: auto;
  margin-right: 32px;
  font-weight: 400;
`;

const Tag = styled.span`
  background: ${({color, theme}) => theme.colors.interfacePalette[color].light};
  color: ${({color, theme}) => theme.colors.interfacePalette[color].dark} !important;
  padding: 4px 12px;
  border-radius: 100px;
  font-size: 16px;
  font-weight: bold;
  width: auto;
`;

const SectionReview = ({highlightTooltipRef, strikethroughTooltipRef}) => {
  const [filter, setFilter] = useState('all');
  const {
    methods: {
      setCurrentIndex,
      setMcatTheme,
      setNavigationFilter,
      transitionBlock
    },
    variables: {
      quizProgress,
      mcatTheme
    }
  } = useTestNavigatorContext();
  const {modalDispatch} = useModalContext();
  const incomplete = quizProgress.reduce((acc, {questions}) => acc + (questions || []).filter(({seen, selectedAnswerIndex}) => selectedAnswerIndex === -1).length, 0);
  const unseen = quizProgress.reduce((acc, {questions}) => [...acc, ...(questions || [])], [])?.filter(({seen, selectedAnswerIndex}) => !seen && selectedAnswerIndex > -1)?.length
  const flagged = quizProgress.reduce((acc, {questions}) => [...acc, ...(questions || [])], [])?.filter(({didMark}) => didMark)?.length
  return (
    <Container mcatTheme={mcatTheme}>
      <Title>
        Section Review
        <ReviewButton onClick={() => {
          switch (filter) {
            case 'all':
              setNavigationFilter('all');
              setCurrentIndex(1,0);
              break;
            case 'incomplete':
              setNavigationFilter({key: 'selectedAnswerIndex', value: -1})
              transitionBlock('reviewIncomplete');
              break;
            case 'unseen':
              setNavigationFilter({key: 'seen', value: false})
              transitionBlock('reviewUnseen');
              break;
            case 'flagged':
              setNavigationFilter({key: 'didMark', value: true})
              transitionBlock('reviewMarked');
              break;
            default:
              break;
          }
        }}>
          {filter === 'all' ? 'Review All' : filter === 'incomplete' ? 'Review Incomplete' : filter === 'unseen' ? 'Review Unseen' : 'Review Flagged'}
        </ReviewButton>
      </Title>
      {/* Filter selector - All (count of all), Incomplete (count of incomplete), Unseen (count of unseen) */}
      <FilterTabContainer>  
        <FilterTab mcatTheme={mcatTheme} selected={filter === 'all'} onClick={() => setFilter('all')}>All ({quizProgress.reduce((acc, {questions}) => acc + (questions || []).length, 0)})</FilterTab>
        {incomplete ? <FilterTab mcatTheme={mcatTheme} selected={filter === 'incomplete'} onClick={() => setFilter('incomplete')}>Incomplete ({incomplete})</FilterTab> : null}
        {unseen ? <FilterTab mcatTheme={mcatTheme} selected={filter === 'unseen'} onClick={() => setFilter('unseen')}>Unseen ({unseen})</FilterTab> : null}
        {flagged ? <FilterTab selected={filter === 'flagged'} onClick={() => setFilter('flagged')}>Flagged ({flagged})</FilterTab> : null}
      </FilterTabContainer>

      <ReviewTable>
        <thead>
          <tr>
            <th>Question</th>
            <th>Title</th>
            <th>Status</th>
            <th>Flagged</th>
            <th></th>
          </tr>
        </thead>
        {quizProgress.reduce((acc, { questions }, blockIndex) => [...acc, ...(questions || []).map((question, index) => {
          if (filter === 'incomplete' && question.selectedAnswerIndex !== -1) return;
          if (filter === 'unseen' && question.seen) return;
          if (filter === 'flagged' && !question.didMark) return;
          return (
            <tr>
              <td>
                {acc.length + index + 1}
              </td>
              <td>
                Question
              </td>
              <td style={{fontWeight: 'bold'}}>
                <Tag color={question.selectedAnswerIndex > -1 ? 'green' : question.seen ? 'red' : 'yellow'}>{question.selectedAnswerIndex > -1 ? 'Complete' : question.seen ? 'Incomplete' : 'Unseen'}</Tag>
              </td>
              <td>
                {!question.didMark ? 'No' : <>Yes <img src={flagFilled} style={{width: 16, height: 16, marginLeft: 8}} /></>}
              </td>
              <td>
                <ReviewText onClick={() => setCurrentIndex(blockIndex, index)}>Review</ReviewText>
              </td>
            </tr>
          );
        })], [])}
      </ReviewTable>
    </Container>
  );
};


SectionReview.defaultProps = {};
SectionReview.propTypes = {};

export default SectionReview;